export const MAX_AGE = 60 * 5 // 5 min
export const MAX_CACHE_AGE = 60 * 60 // 1 hour
export const MAX_CACHE_AGE_HOME = 60 * 60 * 24 * 30// 30 days
export const MAX_CACHE_AGE_PRODUCT = 60 * 60 * 24 // 1 day
export const STALE_WHILE_REVALIDATE = 60 * 15 // 15 min
export const THEME_COLOR = '#f3f3f3'
export const MAX_WISHLIST_COUNT = 2
export const DEFAULT_SITE_TITLE = 'Brunello Cucinelli'

/**
 * Default editorial path prefix (fallback).
 * The actual runtime value is read from getConfig().customParams.editorialPathPrefix,
 * configurable per environment in the sandbox JSON files without code changes.
 */
export const DEFAULT_EDITORIAL_PATH_PREFIX = 'stories'